import { BaseApiClient } from './base'

export interface AuthConsentData {
  accepted_terms: boolean
  accepted_marketing: boolean
}

export class AuthApi extends BaseApiClient {
  async authenticateWithGoogle(
    code: string, 
    redirectUri: string, 
    referralCode?: string,
    consent?: AuthConsentData
  ): Promise<{ success: boolean; token: string; user: any }> {
    const body: Record<string, string | boolean> = { code, redirect_uri: redirectUri }
    if (referralCode) {
      body.referral_code = referralCode
    }
    if (consent) {
      body.accepted_terms = consent.accepted_terms
      body.accepted_marketing = consent.accepted_marketing
    }
    
    const data = await this.request('/auth/google', {
      method: 'POST',
      body: JSON.stringify(body),
    })
    
    if (data.success) {
      localStorage.setItem('auth_token', data.token)
    }
    
    return data
  }

  async verifyToken(): Promise<any> {
    return this.request('/auth/verify', {
      method: 'POST',
    })
  }

  async deleteAccount(confirmation: string): Promise<{ success: boolean; message: string }> {
    const result = await this.request('/user/account', {
      method: 'DELETE',
      body: JSON.stringify({ confirmation }),
    })
    
    if (result.success) {
      localStorage.removeItem('auth_token')
    }
    
    return result
  }
}

